import React from 'react';
import CommodityForm from './CommodityForm';

const TradeUI = () => {
  // Example data, replace with real data source as needed
  const commodities = [
    {
      commodity: 'Gold',
      symbol: 'GCZ25',
      contract: 'DEC 2025',
      bid: 1985.50,
      ask: 1987.00,
      expiry: '2025-12-31',
      size: '1oz',
      exchange: 'COMEX',
      change: 5.25,
      changePercent: 0.26
    },
    {
      commodity: 'Gold',
      symbol: 'GCZ25',
      contract: 'DEC 2026',
      bid: 2985.50,
      ask: 2987.00,
      expiry: '2026-12-31',
      size: '1oz',
      exchange: 'COMEX',
      change: -6.25,
      changePercent: -0.13
    },
    // Add more rows as needed
  ];

  const handleTrade = (row) => {
    alert(`Trade initiated for ${row.commodity} (${row.contractMonth} ${row.contractYear})`);
  };

  return (
    <div style={{ padding: 32 }}>
      <h2>Trade UI</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#f8fafd', marginTop: 24 }}>
        <thead>
          <tr style={{ background: '#e3eaf2' }}>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Commodity</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Symbol</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Contract</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Size</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Expiry Date</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Bid</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Ask</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Change</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Change %</th>
            <th style={{ padding: 8, border: '1px solid #ddd', textAlign: 'left' }}>Trade</th>
          </tr>
        </thead>
        <tbody>
          {commodities.map((row, idx) => (
            <tr key={idx}>
              <td style={{ padding: 8, border: '1px solid #ddd' }}>{row.commodity}</td>
              <td style={{ padding: 8, border: '1px solid #ddd' }}>{row.symbol}</td>
              <td style={{ padding: 8, border: '1px solid #ddd' }}>{`${row?.contractMonth} ${row?.contractYear}`}</td>
              <td style={{ padding: 8, border: '1px solid #ddd' }}>{row.size}</td>
              <td style={{ padding: 8, border: '1px solid #ddd' }}>{new Date(row.expiry).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}</td>
              <td style={{ padding: 8, border: '1px solid #ddd' }}>${row.bid.toFixed(2)}</td>
              <td style={{ padding: 8, border: '1px solid #ddd' }}>${row.ask.toFixed(2)}</td>
              <td style={{ padding: 8, border: '1px solid #ddd', color: row.change >= 0 ? '#388e3c' : '#d32f2f' }}>{row.change >= 0 ? '+' : ''}{row.change.toFixed(2)}</td>
              <td style={{ padding: 8, border: '1px solid #ddd', color: row.changePercent >= 0 ? '#388e3c' : '#d32f2f' }}>{row.changePercent >= 0 ? '+' : ''}{row.changePercent.toFixed(2)}%</td>
              <td style={{ padding: 8, border: '1px solid #ddd' }}>
                <button
                  style={{ padding: '6px 16px', borderRadius: 6, background: '#1976d2', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 500 }}
                  onClick={() => handleTrade(row)}
                >Trade</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <CommodityForm />



    </div>
  );
};

export default TradeUI;
